import React from 'react';
import { toDateFormat } from 'utils/date';
import { connect } from 'react-redux';
import { getClient } from 'features/clientProfile/ducks/clientProfileActions';
import AssessmentForm from './AssessmentForm';
import { createAssessment, getAssessments } from './ducks/AssessmentActions';
import formValuesSchema from './AssessmentForm/formValuesSchema';

class ProgressCheckIn extends React.Component {
  constructor(props) {
    super(props);

    this.clientId = props.match.params.client_id;
  }

  componentDidMount() {
    this.props.getClient(this.clientId, this.props.history);
    this.props.getAssessments(this.clientId);
  }

  render() {
    const { client, assessments, createAssessment, history } = this.props;

    const firstSession = assessments.filter(
      item => item.assessment_type === 'First Session'
    )[0];
    const birth = firstSession && toDateFormat(firstSession.birthday);

    const formInitVals = Object.assign({}, formValuesSchema);
    formInitVals.assessment_type = 'Progress Check In';
    formInitVals.weight.measurement_unit =
      client &&
      (client.measurement_unit === 'pounds' ? 'lbs' : client.measurement_unit);
    formInitVals.gender = firstSession && firstSession.gender;
    formInitVals.birthdate = birth && {
      month: Number(birth.getMonth()) + 1,
      day: Number(birth.getDate()),
      year: Number(birth.getFullYear())
    };

    return (
      client && (
        <AssessmentForm
          client={client}
          prevUrl={`/clients/${this.clientId}/add-assessment`}
          prevTitle="Add Assessment"
          formInitVals={formInitVals}
          submitAssessmentForm={createAssessment}
          history={history}
        />
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    assessments: state.assessmentsReducer.assessments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getAssessments: clientId => dispatch(getAssessments(clientId)),
    createAssessment: (assessment, history) =>
      dispatch(createAssessment(assessment, history))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressCheckIn);
